<template>
  <router-link
    class="course-lesson-link card text-decoration-none text-light mb-5"
    :to="{
      name: 'lesson',
      params: {
        id: courseId,
        slug,
        lesson: lesson.id
      }
    }"
  >
    <span class="pl-2 mb-2">
      {{ lesson.name }}
    </span>
    <div
      class="banner-preview img-fluid"
      :style="`background-image:url(${lesson.cover})`"
    >
      <i class="icon-controller-play"></i>
    </div>
  </router-link>
</template>

<script>
import get from "lodash/get";
export default {
  props: {
    courseId: {
      type: Number,
      required: false
    },
    lesson: {
      type: Object,
      required: true
    },
    slug: {
      type: String,
      required: ""
    }
  },
  computed: {
    embed() {
      const embed = get(this.lesson, "embed");
      return embed ? embed.replace("watch?v=", "embed/") : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.course-lesson-link {
  border-right: none;
  border-left: none;
  background: transparent;
  text-align: left;
  font-size: 14px;
  border: none;
  font-weight: bold;

  &:hover {
    background: rgba(100, 100, 100, 0.05);
  }

  .circle {
    min-width: 24px;
    min-height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
    }
  }

  span {
    height: 40px;
    text-overflow: ellipsis;
  }
  .banner-preview {
    background-size: cover;
    background-position: center;
    aspect-ratio: 16/9;

    border-radius: 8px;

    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: #fff;
      font-size: 32px;
    }
  }
}
</style>
